/// <reference path="../modules/app.module.ts" />

module App {
    interface IFancyBoxScope extends ng.IScope {
        fancyboxBefore: Function;
        fancyboxTitle: string;
        fancyboxGroup: string;
        fancyboxIndex: number;
        fancyboxContent: string;
        fancyboxWidth: number;
        fancyboxHeight: number;
    }

    interface IFancyBox extends ng.IDirective {

    }

    class FancyBox implements IFancyBox {
         static directiveId: string = "fancybox";
         restrict: string = "A";

        constructor(private $compile: ng.ICompileService) {
        }

        scope = {
            fancyboxBefore: "&",
            fancyboxTitle: "=",
            fancyboxGroup: "@",
            fancyboxIndex: "=",
            fancyboxContent: "=",
            fancyboxWidth: "=",
            fancyboxHeight: "="
        };

        link = ($scope: IFancyBoxScope, element, attrs) => {
            $scope.$on('$destroy', () => { element.off('click'); });

            element.on('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                
                var jElement = $(element);
                var fancyboxType = (jElement.data("fancybox-type") || jElement.attr("fancybox-type")) ? (jElement.data("fancybox-type") || jElement.attr("fancybox-type")).toString() : null;
                
                if ($scope.fancyboxGroup) {
                    $.fancybox.open($('[data-fancybox-group=' + $scope.fancyboxGroup + '][href][href!=""]'),
                        {
                            title: $scope.fancyboxTitle || null,
                            prevEffect: 'none',
                            nextEffect: 'none',
                            index: $scope.fancyboxIndex || 0,
                            padding: 0,
                            wrapCSS: 'custom',
                            beforeShow: () => {
                                var beforeShow = $scope.fancyboxBefore;
                                if (beforeShow) {
                                    beforeShow();
                                }
                                this.$compile($(".fancybox-inner"))($scope);
                                $scope.$apply();
                            },
                            helpers: {
                                thumbs: {
                                    width: 68,
                                    height: 68,
                                    position: 'inner-left',
                                    direction: 'vertical'
                                },
                                title: {
                                    type: 'inside',
                                    position: 'top'
                                },
                                overlay: {
                                    fixed: false
                                }
                            }
                        });
                } else if (fancyboxType == 'inline' && $scope.fancyboxContent != null) {

                    $.fancybox($scope.fancyboxContent, {
                        title: $scope.fancyboxTitle || null,
                        padding: 40,
                        topRatio: 0,
                        autoSize: false,
                        autoWidth: ($scope.fancyboxWidth == null || $scope.fancyboxWidth <= 0),
                        autoHeight: ($scope.fancyboxHeight == null || $scope.fancyboxHeight <= 0),
                        fitToView: true,
                        width: $scope.fancyboxWidth,
                        height: $scope.fancyboxHeight,
                        wrapCSS: 'fancybox-custom',
                        closeBtn: true,
                        closeClick: true,
                        modal:false,
                        beforeShow: () => {
                            var beforeShow = $scope.fancyboxBefore;
                            if (beforeShow) {
                                beforeShow();
                            }
                            this.$compile($(".fancybox-inner"))($scope);
                            $scope.$apply();
                        },
                        helpers: {
                            title: {
                                type: 'inside',
                                position: 'top'
                            },
                            overlay: {
                                fixed: false
                            }
                        }
                    });

                } else if (fancyboxType == 'inline-extra' && $scope.fancyboxContent != null) {

                    $.fancybox($scope.fancyboxContent, {
                        title: $scope.fancyboxTitle || null,
                        padding: 40,
                        topRatio: 0,
                        autoSize: false,
                        autoWidth: ($scope.fancyboxWidth == null || $scope.fancyboxWidth <= 0),
                        autoHeight: ($scope.fancyboxHeight == null || $scope.fancyboxHeight <= 0),
                        fitToView: true,
                        width: $scope.fancyboxWidth,
                        height: $scope.fancyboxHeight,
                        wrapCSS: 'fancybox-custom',
                        closeBtn: true,
                        closeClick: true,
                        modal: false,
                        //fixed: true,
                        beforeShow: () => {
                            var beforeShow = $scope.fancyboxBefore;
                            if (beforeShow) {
                                beforeShow();
                            }
                            this.$compile($(".fancybox-inner"))($scope);
                            $scope.$apply();
                        },
                        helpers: {
                            title: {
                                type: 'inside',
                                position: 'top'
                            },
                            overlay: {
                                fixed: false
                            }
                        }
                    });

                } else if (fancyboxType == 'current-position' && $scope.fancyboxContent != null) {

                    $.fancybox($scope.fancyboxContent, {
                        title: $scope.fancyboxTitle || null,
                        padding: 40,
                        autoSize: false,
                        autoWidth: ($scope.fancyboxWidth == null || $scope.fancyboxWidth <= 0),
                        autoHeight: ($scope.fancyboxHeight == null || $scope.fancyboxHeight <= 0),
                        fitToView: true,
                        width: $scope.fancyboxWidth,
                        height: $scope.fancyboxHeight,
                        wrapCSS: 'fancybox-width',
                        closeBtn: true,
                        closeClick: true,
                        modal: false,
                        beforeShow: () => {
                            var beforeShow = $scope.fancyboxBefore;
                            if (beforeShow) {
                                beforeShow();
                            }
                            this.$compile($(".fancybox-inner"))($scope);
                            $scope.$apply();
                        },
                        helpers: {
                            title: {
                                type: 'inside',
                                position: 'top'
                            },
                            overlay: {
                                fixed: false
                            }
                        }
                    });

                } else {
                    $.fancybox.open([jElement], {
                        href: jElement.attr("href"),
                        type: fancyboxType || "image",
                        title: $scope.fancyboxTitle || null,
                        autoSize: false,
                        autoWidth: ($scope.fancyboxWidth == null || $scope.fancyboxWidth <= 0),
                        autoHeight: ($scope.fancyboxHeight == null || $scope.fancyboxHeight <= 0),
                        fitToView: true,
                        fixed: true,
                        width: $scope.fancyboxWidth,
                        height: $scope.fancyboxHeight,
                        wrapCSS: 'fancybox-custom',
                        closeBtn: true,
                        closeClick: true,
                        beforeShow: () => {
                            var beforeShow = $scope.fancyboxBefore;
                            if (beforeShow) {
                                beforeShow();
                            }
                            this.$compile($(".fancybox-inner"))($scope);
                            $scope.$apply();
                        },
                        helpers: {
                            title: {
                                type: 'inside',
                                position: 'top'
                            },
                            overlay: {
                                fixed: false
                            }
                        }
                    });
                }
            });
        }
     }

    app.directive(FancyBox.directiveId, ['$compile', ($compile) =>
        new FancyBox($compile)
    ]);

    class CloseFancyBox {
        static directiveId: string = "closeFancybox";
        restrict: string = "A";

        constructor(private $compile: ng.ICompileService) {
        }

        link = ($scope, element, attrs) => {
            element.on('click',(event) => {
                $.fancybox.close(true);
            });
        }
    }

    app.directive(CloseFancyBox.directiveId, ['$compile', ($compile) =>
        new CloseFancyBox($compile)
    ]);
 }